import { useEffect } from 'react';
import { Language } from '@/lib/i18n';
import { setCanonicalAndHreflang } from '@/lib/seo';

const meta: Record<Language, { title: string; description: string; ogTitle: string; ogDescription: string; lang: string }> = {
  en: {
    title: 'Dr.Vet AI | Scientific Veterinary Assistant - Invest Now',
    description: 'Research-backed AI for veterinary clinics. Automatic medical records and global scaling. Proven in wartime Ukraine. WVAC 2026 Tokyo.',
    ogTitle: 'Dr.Vet AI | Scientific Veterinary Assistant - Invest Now',
    ogDescription: 'Research-backed AI for veterinary clinics. Automatic medical records and global scaling. Proven in wartime Ukraine. WVAC 2026 Tokyo.',
    lang: 'en',
  },
  uk: {
    title: 'Dr.Vet AI | Науковий ветеринарний асистент - Інвестуйте',
    description: 'AI для ветклінік на основі досліджень. Автоматичні медичні записи та глобальне масштабування. Перевірено в Україні. WVAC 2026 Токіо.',
    ogTitle: 'Dr.Vet AI | Науковий ветеринарний асистент - Інвестуйте',
    ogDescription: 'AI для ветклінік на основі досліджень. Автоматичні медичні записи та глобальне масштабування. Перевірено в Україні. WVAC 2026 Токіо.',
    lang: 'uk',
  },
  ja: {
    title: 'Dr.Vet AI | 科学に基づく獣医AIアシスタント - 未来への投資',
    description: '研究に裏打ちされた獣医クリニック向けAI。自動医療記録入力とグローバル展開。ウクライナの戦時下で実証済み。WVAC 2026 東京（4月21〜24日）にて発表。',
    ogTitle: 'Dr.Vet AI | 科学に基づく獣医AIアシスタント - 未来への投資',
    ogDescription: '研究に裏打ちされた獣医クリニック向けAI。自動医療記録入力とグローバル展開。ウクライナの戦時下で実証済み。WVAC 2026 東京にて発表。',
    lang: 'ja',
  },
};

function setMetaContent(selector: string, content: string) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute('content', content);
}

export function useDocumentMeta(lang: Language) {
  useEffect(() => {
    const m = meta[lang];
    document.title = m.title;
    document.documentElement.lang = m.lang;
    setMetaContent('meta[name="description"]', m.description);
    setMetaContent('meta[property="og:title"]', m.ogTitle);
    setMetaContent('meta[property="og:description"]', m.ogDescription);
    setMetaContent('meta[name="twitter:title"]', m.ogTitle);
    setMetaContent('meta[name="twitter:description"]', m.ogDescription);
    setCanonicalAndHreflang('/', lang);
  }, [lang]);
}
